import { CMS } from "../../components/cms/cms";
import { For, Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { loadAds, loadArtistCms, loadCms, setPageTitle, setSubMenu } from "../../app";
import slugify from "slugify";
import { RawHtml } from "../../components/raw-html";
import { Img } from "../../components/universal/image";
import { useRouteData } from "@solidjs/router";
import { SearchArtworks } from "../../components/search-artworks";
import { SalonEntrantImage } from "../../Types";

type State = {
    isContentReady: boolean;
}
type SalonEntrant = {
    Id: number;
    FullName: string;
    Country: string;
    Website: string;
    HasSocial: boolean;
    IsARCArtist: boolean;
    IsHighSchoolStudent: boolean;
    Biography: string;
    Member: {
        Id: string;
        ArtistId: string;
        Artist: {
            Id: string;
            FullName: string;
        }
    }
    Social: {
        Facebook: string;
        Twitter: string;
        Instagram: string;
    }
    Salon: {
        Id: number;
        Name: string;
    }
    SalonEntrantImages: SalonEntrantImage[];
}

export function HomeArtistPage() {
    const [state, setState] = createStore<State>({ isContentReady: false });
    const [entrant, setEntrant] = createStore<SalonEntrant>({} as SalonEntrant);
    const prefixIfMissing = (url: string, domain: string) => url.indexOf(domain) == -1 ? `https://${domain}.com/${url}` : url;
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setEntrant(routeData.entrant);
        await loadArtistCms();
        await loadAds("7th-arc-salon/introduction");
        setSubMenu("");
        setPageTitle({ text: entrant.FullName });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div id="main-template">
                    <div style="text-align: center;">
                        <h2 style="font-family: Oswald; font-size: 5em;">
                            {entrant.FullName}
                        </h2>
                        <h4 style="padding: 10px; font-size: 2em;">
                            {entrant.Country}
                        </h4>
                        <Show when={entrant.HasSocial}>
                            <div style="padding: 20px;">
                                <Show when={entrant.Social.Facebook}>
                                    <span style="margin-right: 10px;">
                                        <a href={prefixIfMissing(entrant.Social.Facebook, "facebook")} target="_blank">
                                            <img style="height: 2.25em;" src="/Images/icons/facebook.svg" />
                                        </a>
                                    </span>
                                </Show>
                                <Show when={entrant.Social.Instagram}>
                                    <span style="margin-right: 10px;">
                                        <a href={prefixIfMissing(entrant.Social.Instagram, "instagram")} target="_blank">
                                            <img style="height: 2.25em;" src="/Images/icons/instagram.svg" />
                                        </a>
                                    </span>
                                </Show>
                                <Show when={entrant.Social.Twitter}>
                                    <span>
                                        <a href={prefixIfMissing(entrant.Social.Twitter, "twitter")} target="_blank">
                                            <img style="height: 2.25em;" src="/Images/icons/twitter.svg" />
                                        </a>
                                    </span>
                                </Show>
                            </div>
                            <Show when={entrant.Website}>
                                <div style="padding: 20px; margin: 0 auto;">
                                    <a class="tape" target="_blank" href={entrant.Website}>{entrant.Website}</a>
                                </div>
                            </Show>
                        </Show>
                        <Show when={entrant.IsARCArtist}>
                            <p class="landing-page__intro" style="text-align: center; margin: 20px 0;">
                                <a class="btn btn-chunky-lg btn-chunky-goldenrod" style="color: #fff;"
                                    href={`/artist/${slugify(entrant.Member.Artist.FullName)}/${entrant.Member.ArtistId}`}>
                                    (<CMS text id="button::view-arc-gallery">View ARC Gallery</CMS>)
                                </a>
                            </p>
                        </Show>
                    </div>
                    <Show when={entrant.Biography && !entrant.IsHighSchoolStudent}>
                        <div style="margin: 40px;">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="artist-bio">
                                        <RawHtml value={entrant.Biography} />
                                        <CMS id="7th-arc-salon/artist::biography-not-vetted">
                                            <em>* This statement has been provided directly by the artist in association to their 7th<sup>th</sup> International ARC Salon entries. This content has not been edited for typos or grammatical errors and has not been vetted for accuracy.</em>
                                        </CMS>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <For each={entrant.SalonEntrantImages}>{(image) =>
                                        <div style="display: inline-block; vertical-align: top; margin-right: 10px; margin-bottom: 10px;">
                                            <a target="_blank" href={ "/Common/Image?imageId=" + image.NewImage.Id }>
                                                <Img
                                                    src={image.NewImage.URL}
                                                    mode="max" naturalHeight={image.NewImage.Height} naturalWidth={image.NewImage.Width}
                                                    width={300} height={300}
                                                    style="max-width: 300px; max-height: 300px;"
                                                />
                                            </a>
                                        </div>
                                    }</For>
                                </div>
                            </div>
                        </div>
                    </Show>
                    <div>
                        <SearchArtworks filter={{ ContestEntrantId: entrant.Id.toString() } as any} />
                    </div>
                </div>
            </Show>           
        </>
    )
}